import React from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";

const FilterCategory = ({
	careerFilters,
	selectedFilters,
	handleSelectFilter,
}) => {
	const renderCareerFilters = (filters) => {
		const handleKeyDown = (e, filterKey, filter) => {
			if (e.key === "Enter") {
				handleSelectFilter(filterKey, filter);
			}
		};

		return Object.keys(filters).map((filterKey) => (
			<FilterCategoryContainer key={filterKey}>
				<Category>{filters[filterKey].title}</Category>
				{filters[filterKey].filters.map((filter) => {
					const isSelected = selectedFilters.some(
						(selectedFilter) =>
							selectedFilter.category === filterKey &&
							selectedFilter.value === filter.slug
					);

					return (
						<Filter
							key={filter.slug}
							isActive={isSelected}
							onClick={() => handleSelectFilter(filterKey, filter)}
							onKeyDown={(e) => handleKeyDown(e, filterKey, filter)}
							aria-checked={isSelected}
							aria-label={`Filter by ${filter.name}`}
						>
							{filter.name}
						</Filter>
					);
				})}
			</FilterCategoryContainer>
		));
	};
	return <>{renderCareerFilters(careerFilters)}</>;
};

FilterCategory.propTypes = {
	careerFilters: PropTypes.object.isRequired,
	selectedFilters: PropTypes.array.isRequired,
	handleSelectFilter: PropTypes.func.isRequired,
};

const Category = styled.span`
	font-size: 1.8rem;
	font-weight: 900;
	letter-spacing: -0.171px;
`;

const Filter = styled.button`
	cursor: pointer;
	pointer-events: auto;
	font-weight: ${(props) => (props.isActive ? "900" : "400")};
	background: none;
	border: none;
	padding: 0;
	outline: inherit;
	text-align: left;
	height: unset;

	&:focus,
	&:hover {
		box-shadow: none;
		font-weight: ${(props) => (props.isActive ? "900" : "400")};
	}
`;

const FilterCategoryContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2rem;
`;

export default FilterCategory;
